import clsx from 'clsx';
import React from 'react';

import { FormattedMessage } from '@futrli/localisation';

import styles from './technical-issues.scss';

export const TechnicalIssues = () => (
  <span className={clsx(styles.errorColour, 'uiTypeOtherAction')}>
    <FormattedMessage
      id="common.problem_technical_issues"
      defaultMessage="Oops, looks like we're having some technical issues. Please try again!"
    />
  </span>
);
